import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { AllowedToothConditionsHint } from '@/shared/api/protocol-ts/api/core/svc_report_pb';
import { SliceName } from '@/shared/config';

export const allowedToothConditionsAdapter =
  createEntityAdapter<AllowedToothConditionsHint>({
    selectId: (allowedToothConditions: AllowedToothConditionsHint) =>
      allowedToothConditions?.ToothID,
  });

const allowedToothConditionsState =
  allowedToothConditionsAdapter.getInitialState();

type AllowedToothConditionsState = typeof allowedToothConditionsState;

const allowedToothConditionsSlice = createSlice({
  name: SliceName.allowedToothConditions,
  initialState: allowedToothConditionsState,
  reducers: {
    setMany: (state, action: PayloadAction<AllowedToothConditionsHint[]>) =>
      allowedToothConditionsAdapter.setMany(
        state as AllowedToothConditionsState,
        action.payload,
      ),
    setOne: (state, action: PayloadAction<AllowedToothConditionsHint>) =>
      allowedToothConditionsAdapter.setOne(
        state as AllowedToothConditionsState,
        action.payload,
      ),
  },
});

export const { actions } = allowedToothConditionsSlice;

export default allowedToothConditionsSlice.reducer;
